import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IGetTaskAssignmentsResponse } from "./types";

export const getTaskAssignments = async (taskId: string): Promise<IGetTaskAssignmentsResponse> => {
  try {
    const response = await apiClientSource.get(`/task-service/api/task-assignments/task/${taskId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener las asignaciones de la tarea");
    throw error;
  }
};